module.exports = __webpack_public_path__ + "img/bag-x-fill.414315f3.svg";